import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

// import {observerUserStatus} from "../libs/socket";
// import store from '../store';


let redux = reduxCreator.type('USER_FRIENDS').plugin(axiosPlugin, {template: "array"});

let fetchUserFriendsAction = redux.fetchActionGet();

redux.reducerForType('ADD', (state,payload) => {
    let newState = {...state};
    if(payload.data.status === 1){
        newState.data.unshift(payload.data);
        newState.total++;
    }
    return newState;
});

redux.reducerForType('DELETE', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState.data = newState.data.filter(item => item._id.toString() !== payload.data._id.toString());
        newState.total--;
        if(newState.total < 0){
            newState.total = 0;
        }
    }
    return newState;
});

export const subscribeUserStatus = redux.action('SUBSCRIBE', function (params = {}) {
    return {
        subscribe: {
            path : 'USER_STATUS',
            params
        }
    }
});

export const unsubscribeUserStatus = redux.action('UNSUBSCRIBE', function () {
    return {
        unsubscribe: {
            type : redux.types.SUBSCRIBE
        }
    }
});

redux.reducerForType('SUBSCRIBE_DATA', (state,action) => {
    let newState = {...state};
    if (action.payload) {
        newState.data = newState.data.map(item => {
            if (item._id.toString() === action.payload._id.toString()) {
                item.online = action.payload.online;
                item.lastVisit =  action.payload.lastVisit;
            }
            return item;
        });
        // store.dispatch({ type: "ROOMS_UPDATE_STATUS_SOCKET", payload : action.payload })
    }
    return newState;
});

export const fetchUserFriends = (userId, query = {}) => fetchUserFriendsAction(`/users/${userId}/friends?${queryString.stringify(query)}`);
export const resetUserFriends = () => redux.actions.reset();

export const userFriends = redux.reducer();